<template>
  <v-container>
    <div>
        <div style="background-color: rgb(230, 233, 242);">
          <v-img :src="require('../assets/rcp3.png')" max-width="100%" contain>
            <v-row>
                <v-col cols="12" md="6" lg="6">
                  <p style="font-size: 1.05rem; color: rgb(0, 30, 67);padding-left: 20px; margin-top: 15px; line-height: 1.4;"> Welcome to UN iLabCC</p>
                  <p style="font-size: 2rem; color: rgb(0, 30, 67);padding-left: 20px; line-height: 1.4;"><b>UN Information Laboratory on Crime and Corruption for Latin America and the Caribbean (UN iLabCC)</b></p>
                  <p style="font-size: 1.1rem; color: rgb(0, 30, 67);padding-left: 20px; line-height: 1.4;">
                    The United Nations Information Laboratory on Crime and Corruption for Latin America and the Caribbean (UN iLabCC) is the United Nations regional knowledge and policy support platform for addressing corruption, organized crime and related governance, crime and violence challenges linked to SDG 16 and the 2030 Agenda. It provides UN Resident Coordinators, Resident Coordinator Offices and UN Country Teams with integrated policy guidance, expertise, learning resources, international standards and good practices to support coherent and effective United Nations engagement across the region. Access to the platform is restricted to United Nations personnel using United Nations credentials. 
                    <span style="display: inline-block;"> <!-- Ajusta el margen según sea necesario -->
                        <router-link :to="{ name: 'about', params: { id: 1 } }" style="text-decoration: none; font-size: 1.25rem; color: rgb(0, 30, 67);">
                            <b>More information ...</b>
                        </router-link>
                    </span>
                  </p>
                  <p style="font-size: 1.1rem; color: rgb(0, 30, 67);padding-left: 20px;" v-if="userOid === null">
                    To access the contents of UN iLabCC UN staff are invited to 
                    <button @click="signIn">SIGN IN</button>
                  </p>
                </v-col>
            </v-row> 
          </v-img>
        </div>
        <br><br>
        <div>
          <v-row class="mb-1 justify-center mb-n1">
            <!--<v-col class="mb-1 col-md-3">
              <v-card class="mx-auto" max-width="75%" height="150" title="Card title" theme="dark" style="border-top: 5px solid #1BA397; margin-top: 5px;">
                <router-link :to="{ name: 'about', params: { id: 1 } }" style="text-decoration: none;">
                  <v-img class="align-end text-white" contain height="100%" :src="require('../assets/hello1.jpg')">
                    <p style="font-size: 1.1rem; color: rgb(15, 135, 201);">About the LABCC</p>
                  </v-img>   
                </router-link>
              </v-card>
            </v-col>-->
            <v-col class="mb-1" cols="12" md="12">
              <v-card class="mx-auto" max-width="100%" height="90%" title="Card title" theme="dark" style="border-top: 5px solid rgba(26,71,107,1); margin-top: 5px;">
                <router-link to="/resources" style="text-decoration: none;" :style="{ 'pointer-events': userOid ? 'auto' : 'none' }">              
                  <v-row>
                    <v-col class="mb-1" md="10">
                      <p style="font-size: 2rem; color: rgb(0, 30, 67);padding-left: 20px; margin-top: 5px"><b>UN iLabCC - Policy Guidance, Tools and Resources</b></p>
                      <p style="font-size: 1.1rem; color: black;padding-left: 20px;">
                        This section provides Resident Coordinators, Resident Coordinator Offices and United Nations Country Teams with access to a curated collection of international standards, policy tools, methodologies, analytical products, guidance documents, good practices and other resources developed by United Nations entities to support integrated responses to corruption, organized crime and other challenges related to SDG 16 and the 2030 Agenda. Resources are organized by thematic areas and are intended to facilitate evidence-based analysis, policy dialogue, programme design and implementation at the country and regional levels. 
                      </p>
                    </v-col>
                    <v-col class="mb-1" md="2">
                      <v-img class="align-end text-white" contain height="70%" :src="require('../assets/Icon--recursos.png')"></v-img> 
                    </v-col>
                  </v-row> 
                </router-link>         
              </v-card>
            </v-col><!--
            <v-col class="mb-1" md="2" v-if="userOid === null">
              <v-card class="mx-auto" max-width="100%" height="100%" title="Card title" theme="dark" style="border-top: 5px solid #1BA397; margin-top: 5px;" @click="signIn">
                <v-img class="align-end text-white" contain height="100%" :src="require('../assets/hello1.jpg')">
                  <p style="font-size: 1.1rem; color: rgb(0, 30, 67);"><button>Sign In</button></p>
                </v-img>   
              </v-card>
            </v-col>-->
            <!--
            <v-col class="mb-12" md="3">
              <v-card class="mx-auto" max-width="100%" height="100%" title="Card title" theme="dark" style="border-top: 5px solid #009DDC; margin-top: 5px;">
                <router-link to="/events" style="text-decoration: none;">
                  <v-img class="align-end text-white" contain height="100%" :src="require('../assets/hello3.jpg')">
                    <p style="font-size: 1.25rem; color: rgb(15, 135, 201);">Events and Activities</p>
                  </v-img>
                </router-link>
              </v-card>
            </v-col>--> 
          </v-row>
        </div>
        <div>
          <v-row class="mb-1 justify-center mb-n1">
            <v-col class="mb-1" md="3">
              <v-card class="mx-auto" max-width="100%" height="150" title="Card title" theme="dark" style="border-top: 5px solid #1BA397; margin-top: 5px; text-align: center;">
                <router-link :to="{ name: 'about', params: { id: 1 } }" style="text-decoration: none;">
                  <v-img class="align-end text-white" contain height="80%" :src="require('../assets/hello1.jpg')"></v-img>   
                    <p style="font-size: 1.1rem; color: rgb(0, 30, 67);">About the LABCC</p>
                </router-link>
              </v-card>
            </v-col>
            <v-col class="mb-1" md="3">
              <v-card class="mx-auto" max-width="100%" height="150" title="Card title" theme="dark" style="border-top: 5px solid #F2635C; margin-top: 5px; text-align: center;">
                <a style="text-decoration: none;"href="https://www.rcplac.org/en/ibcs-and-working-groups/ibc-on-governance-for-peace-justice-and-strong-institutions" target="_blank">
                  <v-img class="align-end text-white" contain height="80%" :src="require('../assets/hello7.jpg')"></v-img>
                    <p style="font-size: 1.1rem; color: rgb(0, 30, 67); text-decoration: none;">IBC on SDG 16</p>
                </a>
              </v-card>
            </v-col>
            <v-col class="mb-1" md="3">
              <v-card class="mx-auto" max-width="100%" height="150" title="Card title" theme="dark" style="border-top: 5px solid #1BA397; margin-top: 5px; text-align: center;">
                <router-link to="/courses" style="text-decoration: none;" :style="{ 'pointer-events': userOid ? 'auto' : 'none' }">
                  <v-img class="align-end text-white" contain height="80%" :src="require('../assets/E-Learning-Icon.png')"></v-img>
                    <p style="font-size: 1.1rem; color: rgb(0, 30, 67); text-decoration: none; font-family: 'Sofia Sans', sans-serif !important;">E-learning</p>
                </router-link>
              </v-card>
            </v-col>
            <v-col class="mb-1" md="3">
              <v-card class="mx-auto" max-width="100%" height="150" title="Card title" theme="dark" style="border-top: 5px solid #F2635C; margin-top: 5px; text-align: center;">
                <a style="text-decoration: none;"href="https://www.rcplac.org/en" target="_blank">
                  <v-img class="align-end text-white" contain height="80%" :src="require('@/assets/rcplogo.png')"></v-img>
                  <p style="font-size: 1.1rem; color: rgb(0, 30, 67); text-decoration: none;">RCP LAC Collaborative Platform</p>
                </a>
              </v-card>
            </v-col>
            <!--
            <v-col class="mb-1" md="4">
              <v-card class="mx-auto" max-width="100%" height="90%" title="Card title" theme="dark" style="border-top: 5px solid #F2635C; margin-top: 5px;">
                <v-row class="d-flex justify-center">
                  <v-col cols="12" md="3">
                    <v-img class="align-end text-white" max-width="100%" max-height="100%" contain :src="require('../assets/hello5.jpg')"></v-img>
                  </v-col>
                  <v-col cols="12" md="9">
                    <div class="ml-4">
                      <br>
                      <p style="font-size: 18px; color: rgb(0, 30, 67);">Visit <br> 
                        <b><a style="color: rgb(15, 135, 201);" href="https://www.rcplac.org/en" target="_blank">RCP LAC Collaborative Platform</a></b><br>
                      </p>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col class="mb-1" md="4">
              <v-card class="mx-auto" max-width="100%" height="90%" title="Card title" theme="dark" style="border-top: 5px solid #F79321; margin-top: 5px;">
                <v-row class="d-flex justify-center">
                  <v-col cols="12" md="3">
                    <v-img class="align-end text-white" max-width="100%" max-height="100%" contain :src="require('../assets/hello5.jpg')"></v-img>
                  </v-col>
                  <v-col cols="12" md="9">
                    <div class="ml-4">
                      <p style="font-size: 18px; color: rgb(0, 30, 67);">Visit <br> 
                        <b><a style="color: rgb(15, 135, 201);" href="https://agenda2030lac.org/" target="_blank">2030 Agenda in Latin America and the Caribbean</a></b><br> 
                        Regional knowledge management platform. 
                      </p>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>-->
          </v-row>
        </div>
    </div>
  </v-container>
</template>

<script>
import { bus } from '../main.js';

  export default {
    name: 'HelloWorld',

    data: () => ({
      ecosystem: [
        {
          text: 'Organized crime',
          href: 'https://github.com/vuetifyjs/vuetify-loader',
        },
        {
          text: 'Money laundering',
          href: 'https://github.com/vuetifyjs/vuetify',
        },
        {
          text: 'Human trafficking and migrant smuggling',
          href: 'https://github.com/vuetifyjs/awesome-vuetify',
        },
      ],
      importantLinks: [
        {
          text: 'Drugs',
          href: 'https://vuetifyjs.com',
        },
        {
          text: 'Environmental crimes',
          href: 'https://community.vuetifyjs.com',
        },
        {
          text: 'Gender-based violence',
          href: 'https://madewithvuejs.com/vuetify',
        },
        {
          text: 'Firearms',
          href: 'https://twitter.com/vuetifyjs',
        },
      ],
      whatsNext: [
        {
          text: 'Corruption',
          href: 'https://vuetifyjs.com/components/api-explorer',
        },
        {
          text: 'Cybercrime',
          href: 'https://vuetifyjs.com/getting-started/pre-made-layouts',
        },
        {
          text: 'Crime prevention and criminal justice',
          href: 'https://vuetifyjs.com/getting-started/frequently-asked-questions',
        },
      ],
    }),
    computed: {    
      userOid() {
        // Aquí obtén el nombre del usuario autenticado desde Vuex o desde el almacenamiento local
        const oid_usuario = localStorage.getItem('oidu');
        return oid_usuario;
      },
    },
    methods: {
      signIn() {
        bus.$emit('open-login-dialog');
      }
    },
  }
</script>
<style>
    p {
      font-family: 'Heebo', sans-serif !important;
        font-size: 17px;        
        line-height: 1.6em;
    }
    h1 {
      font-family: 'Heebo', sans-serif !important;
        font-size: 2.5rem;
    }
    h2 {
      font-family: 'Sofia Sans', sans-serif !important;
    }
    h3 {
      font-family: 'Sofia Sans', sans-serif !important;
    }
    h5 {
        font-family: 'Sofia Sans', sans-serif !important;
        font-size: 1.25rem;
    }
    
</style>
